/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_CompletedInputs */

const en_status_completed = /** @type {(inputs: Status_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`completed`)
};

const he_status_completed = /** @type {(inputs: Status_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הושלם`)
};

/**
* | output |
* | --- |
* | "completed" |
*
* @param {Status_CompletedInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const status_completed = /** @type {((inputs?: Status_CompletedInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_CompletedInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_completed(inputs)
	return he_status_completed(inputs)
});